export default class Tickets
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Tickets.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$$filterQuery = this.DOM.$el.querySelectorAll(this.options.selectorFilterQuery)
        this.DOM.$$group = this.DOM.$el.querySelectorAll(this.options.selectorGroup)
        this.DOM.$$ticket = this.DOM.$el.querySelectorAll(this.options.selectorTicket)
        this.DOM.$$showToggle = this.DOM.$el.querySelectorAll(this.options.selectorShowToggle)
        this.DOM.$filter = this.DOM.$el.querySelector(this.options.selectorFilter)
        this.DOM.$filterInput = this.DOM.$el.querySelector(this.options.selectorFilterInput)
        this.DOM.$filterReset = this.DOM.$el.querySelector(this.options.selectorFilterReset)

        this.DOM.$$showToggle.forEach($showToggle => {
            $showToggle.addEventListener('click', this.onShowToggleClick.bind(this))
        })

        if (this.DOM.$filterInput) {
            this.DOM.$filterInput.addEventListener('keyup', this.onFilterInputKeyUp.bind(this))
        }

        if (this.DOM.$filterReset) {
            this.DOM.$filterReset.addEventListener('click', this.onFilterResetClick.bind(this))
        }
    }

    onFilterInputKeyUp(e) {
        if (e.key === 'Enter') {
            e.preventDefault()
        }

        const filter = e.target.value.trim()
        const regExp = new RegExp(filter, 'i')

        if (filter.length > 0) {
            this.DOM.$$ticket.forEach($ticket => {
                const search = $ticket.dataset.ticketsSearch

                if (search) {
                    $ticket.classList.toggle(this.options.classNameIsFilterMatch, search.normalize("NFD").replace(/\p{Diacritic}/gu, "").match(regExp))
                }
            })

            this.DOM.$el.classList.add(this.options.classNameIsFiltering)
        } else {
            this.DOM.$el.classList.remove(this.options.classNameIsFiltering)
        }

        this.updateFilterQueries(filter)
        this.updateNumbers()
    }

    onFilterResetClick() {
        this.resetFilter()
        this.updateFilterQueries('')
        this.updateNumbers()
    }

    onShowToggleClick(e) {
        const $group = e.target.closest(this.options.selectorGroup)

        if ($group) {
            $group.classList.toggle(this.options.classNameIsShowAll)
        }

        this.resetFilter()
        e.preventDefault()
    }

    resetFilter() {
        this.DOM.$el.classList.remove(this.options.classNameIsFiltering)
        this.DOM.$filterInput.value = ''

        this.DOM.$$ticket.forEach($ticket => {
            $ticket.classList.remove(this.options.classNameIsFilterMatch)
        })
    }

    updateFilterQueries(query) {
        this.DOM.$$filterQuery.forEach($filterQuery => {
            $filterQuery.innerHTML = query
        })
    }

    updateNumbers() {
        const isFiltering = this.DOM.$el.classList.contains(this.options.classNameIsFiltering)

        this.DOM.$$group.forEach($group => {
            const $num = $group.querySelector(this.options.selectorNum);
            let num;

            if ($num) {
                if (isFiltering) {
                    num = $group.querySelectorAll(this.options.selectorTicket + '.' + this.options.classNameIsFilterMatch).length
                } else {
                    num = $group.querySelectorAll(this.options.selectorTicket).length
                }
            }

            $num.innerText = num
            $group.dataset.ticketsNum = num
        })
    }
}

Tickets.prototype.defaults = {
    classNameIsFiltering: 'is-filtering',
    classNameIsFilterMatch: 'is-filterMatch',
    classNameIsShowAll: 'is-showAll',
    selectorFilter: '.js-ticketsFilter',
    selectorFilterQuery: '.js-ticketsFilterQuery',
    selectorGroup: '.js-ticketsGroup',
    selectorNum: '.js-ticketsNum',
    selectorShowToggle: '.js-ticketsShowToggle',
    selectorTicket: '.js-ticketsTicket',
    selectorFilterInput: '.js-ticketsFilterInput',
    selectorFilterReset: '.js-ticketsFilterReset',
}